import './new-request-type.scss';

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormRequestType from "../form-request-type/form-request-type";
import { useNewRequestType } from './new-request-type.hook';

export function NewRequestType() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewRequestType();

  return (
    <div id="NewRequestType" className="request-type">
      <HeaderContent
        title={<h1>New Request Type</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormRequestType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewRequestType;